import { Dispatch, ReactNode } from "react";

import SimpleBar from 'simplebar-react';

export interface SettingsContainerTitleProps {
	isExpanded: boolean;
	setIsExpanded: (isExpanded: boolean) => void;
}

export interface SettingsContainerProps {
	settingTitleChild: (props: SettingsContainerTitleProps) => ReactNode;

	contentChild: ReactNode;
	actionsChild?: ReactNode;
	setIsExpanded: Dispatch<boolean>;
}

export const SettingsContainerExpandedComponent = (props: SettingsContainerProps) => {
	return (
		<div className="settings-container-expanded">
			<div className="settings-header">
				{ props.settingTitleChild({ isExpanded: true, setIsExpanded: props.setIsExpanded }) }
				{/* <a onClick={() => props.setIsExpanded(false)}>
					<i className="fa fa-angle-left"></i>
					<span>{ props.title }</span>
				</a> */}
			</div>
			<SimpleBar className='settings-content'>
				<div className="settings-content-wrapper">
					{props.contentChild}
				</div>
			</SimpleBar>
			{
				!props.actionsChild
					? null
					: (
						<div className="settings-actions">
							{ props.actionsChild }
						</div>
					)
			}
		</div>
	);
}
export const SettingsContainerCollapsedComponent = (props: SettingsContainerProps) => {
	return (
		<div className="settings-container-collapsed">
			{ props.settingTitleChild({ isExpanded: false, setIsExpanded: props.setIsExpanded }) }
			{/*  */}
		</div>
	);
}
